
const initialState = {
    listType: "box",
  };


  
  export const listType = (namespace) => (state = initialState, action) => {
    switch (action.type) {
      case `${namespace}/CHANGE_LIST_TYPE`: {
        return {...state, listType: action.data};
      }
 
      default:
        return state;
    }
  };
  